// extracted by mini-css-extract-plugin
module.exports = {"cityResultImage":"CityResultImage_cityResultImage__1oRcy"};